var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import Button from '@m4b-design/button';
import { IconDown } from '@arco-design/iconbox-react-m4b-next';
import { useConfigContext } from '@m4b-design/config-provider';
import { useI18nCopy } from '../hooks/useI18nCopy';
var expandNodesStyle = {
    textAlign: 'center',
    margin: '5px 0 0 -15px',
    cursor: 'pointer',
};
export var MoreIcon = function (props) {
    var _a;
    var globalPrefixCls = useConfigContext().prefixCls;
    var prefixCls = "".concat(globalPrefixCls, "-alert");
    var t = useI18nCopy();
    return (React.createElement("div", __assign({ style: expandNodesStyle, className: "".concat(prefixCls, "-expand-icon-wrapper") }, ((_a = props.containerProps) !== null && _a !== void 0 ? _a : {})),
        React.createElement(Button, { type: "text", size: "mini" },
            t.showMore,
            React.createElement(IconDown, null))));
};
